<template>
  <div class="spercia-account-edit-box">
    <div class="spercia-account-edit">
      <el-form
        :model="innerForm"
        :rules="rules"
        :disabled="disabled"
        ref="innerForm"
        label-width="135px"
      >
        <div class="spercia-account-edit-item">
          <h2>主体信息</h2>
          <div class="panel-box">
            <div class="spercia-account-title">
              <span>主体身份</span>
              <span class="desc-info"
                >请上传"营业执照"，需年检章齐全，当年注册除外</span
              >
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="营业执照照片：" prop="license_copy_img">
                  <el-upload
                    class="avatar-uploader"
                    name="img"
                    :action="$http.defaults.baseURL + '/pay/uploadCertificate'"
                    :show-file-list="false"
                    :data="{
                      type: 'license_copy',
                    }"
                    :on-success="
                      (res, file) =>
                        handleAvatarSuccess(res, file, 'license_copy')
                    "
                    :before-upload="beforeAvatarUpload"
                  >
                    <el-image
                      v-if="innerForm.license_copy_img"
                      :src="
                        $http.defaults.resource + innerForm.license_copy_img
                      "
                      class="avatar"
                    ></el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <p class="spercia-account-describe">
                    1.请上传彩色照片 or 彩色扫描件 or
                    加盖公章鲜章的复印件，要求正面拍摄，露出证件四角且清晰、完整，所有字符清晰可识别，不得反光或遮挡。不得翻拍、截图、镜像、PS。
                  </p>
                  <p class="spercia-account-describe">
                    2.图片只支持JPG、BMP、PNG格式，文件大小不能超过2M。
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="spercia-account-title">
              <span>法定代表人证件 </span>
              <span class="desc-info">请上传法定代表人的证件信息</span>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="身份证人像照片：" prop="id_card_copy_img">
                  <el-upload
                    class="avatar-uploader"
                    name="img"
                    :action="$http.defaults.baseURL + '/pay/uploadCertificate'"
                    :show-file-list="false"
                    :data="{
                      type: 'id_card_copy',
                    }"
                    :on-success="
                      (res, file) =>
                        handleAvatarSuccess(res, file, 'id_card_copy')
                    "
                    :before-upload="beforeAvatarUpload"
                  >
                    <el-image
                      v-if="innerForm.id_card_copy_img"
                      :src="
                        $http.defaults.resource + innerForm.id_card_copy_img
                      "
                      class="avatar"
                    ></el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <p class="spercia-account-describe">
                    1.请上传彩色照片 or 彩色扫描件 or
                    加盖公章鲜章的复印件，要求正面拍摄，露出证件四角且清晰、完整，所有字符清晰可识别，不得反光或遮挡。不得翻拍、截图、镜像、PS。
                  </p>
                  <p class="spercia-account-describe">
                    2.图片只支持JPG、BMP、PNG格式，文件大小不能超过2M。
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="身份证国徽照片："
                  prop="id_card_national_img"
                >
                  <el-upload
                    class="avatar-uploader"
                    name="img"
                    :action="$http.defaults.baseURL + '/pay/uploadCertificate'"
                    :show-file-list="false"
                    :data="{
                      type: 'id_card_national',
                    }"
                    :on-success="
                      (res, file) =>
                        handleAvatarSuccess(res, file, 'id_card_national')
                    "
                    :before-upload="beforeAvatarUpload"
                  >
                    <el-image
                      v-if="innerForm.id_card_national_img"
                      :src="
                        $http.defaults.resource + innerForm.id_card_national_img
                      "
                      class="avatar"
                    ></el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <p class="spercia-account-describe">
                    1.请上传彩色照片 or 彩色扫描件 or
                    加盖公章鲜章的复印件，要求正面拍摄，露出证件四角且清晰、完整，所有字符清晰可识别，不得反光或遮挡。不得翻拍、截图、镜像、PS。
                  </p>
                  <p class="spercia-account-describe">
                    2.图片只支持JPG、BMP、PNG格式，文件大小不能超过2M。
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="spercia-account-edit-item">
          <h2>经营信息</h2>
          <div class="panel-box">
            <div class="spercia-account-title">
              <span>经营信息 </span>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="商户简称：" prop="merchant_shortname">
                  <el-input
                    maxlength="100"
                    style="width: 300px"
                    v-model="innerForm.merchant_shortname"
                  ></el-input>
                  <p class="spercia-account-describe mt-8">
                    1、在支付完成页向买家展示，需与微信经营类目相关。
                  </p>
                  <p class="spercia-account-describe">2、简称要求</p>
                  <p class="spercia-account-describe">
                    ①
                    不支持单纯以人名来命名，若为个体户经营，可用“个体户+经营者名称”或“经营者名称+业务”命名，如“个体户张三”或“张三餐饮店”；
                  </p>
                  <p class="spercia-account-describe">
                    ②
                    不支持无实际意义的文案，如“XX特约商户”、“800”、“XX客服电话XXX”；
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="客服电话：" prop="service_phone">
                  <el-input
                    style="width: 300px"
                    maxlength="100"
                    v-model="innerForm.service_phone"
                  ></el-input>
                  <p class="spercia-account-describe mt-8">
                    1、请填写真实有效的客服电话，将在交易记录中向买家展示，提供咨询服务
                  </p>
                  <p class="spercia-account-describe">
                    2、请确保电话畅通，以便入驻后平台回拨确认。
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="spercia-account-edit-item">
          <h2>结算账户</h2>
          <div class="panel-box">
            <div class="spercia-account-title">
              <span>结算账户</span>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="账户类型：">
                  <span>对公账户</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="开户银行：" prop="account_bank">
                  <el-select
                    style="width: 300px"
                    v-model="innerForm.account_bank"
                    placeholder="请选择"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="(item, index) in accountBankOptions"
                      :key="index"
                      :label="item.title"
                      :value="item.title"
                    >
                    </el-option>
                  </el-select>
                  <p class="spercia-account-describe mt-8">
                    城市商业银行、农村商业银行、信用合作联社及其他银行,请选择“其他银行”
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="开户支行：" prop="bank_address_code">
                  <el-cascader
                    v-model="innerForm.bank_address_code"
                    :options="regionArr"
                    @change="handleAreaChange"
                  >
                  </el-cascader>
                  <!-- <el-select
                    style="width: 145px; margin-right: 10px"
                    v-model="innerForm.bank_address_1"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in options"
                      :key="index"
                      :label="item.title"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    style="width: 145px"
                    v-model="innerForm.bank_address_2"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in options"
                      :key="index"
                      :label="item.title"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select> -->
                  <p class="spercia-account-describe mt-8">
                    如果找不到所在城市，请选择所在地区或者上级城市
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="银行帐号：" prop="account_number">
                  <el-input
                    style="width: 300px"
                    maxlength="100"
                    v-model="innerForm.account_number"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="spercia-account-edit-item">
          <h2>超级管理员</h2>
          <div class="panel-box">
            <div class="spercia-account-title">
              <span>超级管理员信息 </span>
              <span class="desc-info"
                >超级管理员将接收开户信息及完成签约，并可进行商户号的日常重要管理及资金操作。请确定超级管理员为商户法定代表人再进行操作。</span
              >
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="手机号码：" prop="mobile_phone">
                  <el-input
                    style="width: 300px"
                    maxlength="100"
                    v-model="innerForm.mobile_phone"
                  ></el-input>
                  <p class="spercia-account-describe mt-8">
                    用于接收微信支付的重要管理信息及日常操作验证码，并进行短信验证
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="邮箱：" prop="contact_email">
                  <el-input
                    style="width: 300px"
                    maxlength="100"
                    v-model="innerForm.contact_email"
                  ></el-input>
                  <p class="spercia-account-describe mt-8">
                    用于接收微信支付的开户邮件及日常业务通知
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div class="btn-footer" v-if="!disabled">
        <el-button type="primary" @click="submitForm">立即申请</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { regionData } from "element-china-area-data";
export default {
  data() {
    return {
      disabled: false,
      regionArr: regionData,
      innerForm: {
        // license_copy_img: "",
        // id_card_copy_img: "",
        // id_card_national_img: "",
        // merchant_shortname: "",
        // service_phone: "",
        // account_bank: "",
        // bank_address_1: "",
        // bank_address_2: "",
        // account_number: "",
        // mobile_phone: "",
        // contact_email: "",
        // bank_address_code: ["44", "4401", "440103"],
        // account_bank: "中国银行",
        // account_name: "广州体科信息科技有限公司",
        // account_number: "656177082971",
        // card_period_begin: "2014-04-16",
        // card_period_end: "2024-04-16",
        // contact_email: "eigene@163.com",
        // contact_name: "章慈晖",
        // id_card_copy:
        //   "V1_jpdODa8tHwva0500OvjA7h4JK-LSHmOfHxB6-FGcOqrekhSI3Rj_IeGw5U1DFvkxG5OlhsNUngMDUMMB-4njxQLJOzY9eQhmv6giwKWUAjk",
        // id_card_copy_img: "/certificate/1705544395289.png",
        // id_card_name: "章慈晖",
        // id_card_national:
        //   "V1_3UtVGWp04KCj-kSIaAIFCB4JK-LSHmMT4yS-y7plEDNKWN27z8GqIaDy5E1DFvkxIymlfA0x0cXnA0AWdzvoSwLJOzY9eQhmv6giwKWUAjk",
        // id_card_national_img: "/certificate/1705544402838.png",
        // id_card_number: "421202199403010013",
        // id_card_address: "湖北省咸宁市咸安区永安东山巷8-36号",
        // legal_person: "章慈晖",
        // license_copy:
        //   "V1_PEJSVddohVrN_Ypaer0Mkh4JK-LSHmMWRnmY3PmngVfqQV3OKap1IYKO6k1DFvkxU4DdPtpRbuox8K7P2IzVNgLJOzY9eQhmv6giwKWUAjk",
        // license_copy_img: "/certificate/1705544374780.jpg",
        // license_number: "91440104MACCL2BQ21",
        // merchant_name: "广州体科信息科技有限公司",
        // merchant_shortname: "体科运动",
        // mobile_phone: "13226146131",
        // service_phone: "13226146131",
        bank_address_code: [],
        account_bank: "",
        account_name: "",
        account_number: "",
        card_period_begin: "",
        card_period_end: "2",
        contact_email: "",
        contact_name: "",
        id_card_copy:
          "",
        id_card_copy_img: "",
        id_card_name: "",
        id_card_national:
          "",
        id_card_national_img: "",
        id_card_number: "",
        id_card_address: "",
        legal_person: "",
        license_copy:
          "",
        license_copy_img: "",
        license_number: "",
        merchant_name: "",
        merchant_shortname: "",
        mobile_phone: "",
        service_phone: "",
      },
      rules: {
        license_copy_img: [
          { required: true, message: "请上传营业执照照片", trigger: "blur" },
        ],
        id_card_copy_img: [
          { required: true, message: "请上传身份证人像照片", trigger: "blur" },
        ],
        id_card_national_img: [
          { required: true, message: "请上传身份证国徽照片", trigger: "blur" },
        ],
        merchant_shortname: [
          { required: true, message: "请输入商户简称", trigger: "blur" },
        ],
        service_phone: [
          { required: true, message: "请输入客服电话", trigger: "blur" },
        ],
        account_bank: [
          { required: true, message: "请选择开户银行", trigger: "change" },
        ],
        bank_address_code: [
          { required: true, message: "请选择开户支行", trigger: "change" },
        ],
        account_number: [
          { required: true, message: "请输入银行帐号", trigger: "blur" },
        ],
        mobile_phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
        ],
        contact_email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
        ],
      },
      options: [],
      accountBankOptions: [
        {
          title: "工商银行",
        },
        {
          title: "农业银行",
        },
        {
          title: "中国银行",
        },
        {
          title: "建设银行",
        },
        {
          title: "交通银行",
        },
        {
          title: "中信银行",
        },
        {
          title: "光大银行",
        },
        {
          title: "华夏银行",
        },
        {
          title: "民生银行",
        },
        {
          title: "广发银行",
        },
        {
          title: "平安银行",
        },
        {
          title: "招商银行",
        },
        {
          title: "兴业银行",
        },
        {
          title: "邮政储蓄银行",
        },
        {
          title: "中信银行",
        },
        {
          title: "北京银行",
        },
        {
          title: "宁波银行",
        },
      ],
    };
  },
  created() {
    this.disabled = this.$route.query.disabled === 'true';
    debugger
    this.innerForm.adminId = JSON.parse(localStorage.getItem("admins")).id;
    let id = this.$route.query.id;
    if (id) {
      this.getApplymentData(id);
    }
  },
  methods: {
    submitForm() {
      this.$refs.innerForm.validate((valid) => {
        console.log(valid);
        if (!valid) {
          return;
        }
        //   发送请求
        let load = this.$loading();
        this.$http
          .post("/pay/applyMerchantShipment", {
            innerForm: this.innerForm,
          })
          .then((res) => {
            load.close();
            if (res.status !== 200) {
              this.$message({
                showClose: true,
                message: "发布失败",
                type: "error",
              });
              return;
            }
            if (res.data.code == -1) {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: "error",
              });
              return;
            }
            if(res.data.data.errCode) {
                this.$message({
                showClose: true,
                message: res.data.data.errMsg,
                type: "error",
              });
               this.getApplymentData(res.data.data.innerForm.id);
               return
            }
            this.$message({
              showClose: true,
              message: "申请已提交",
              type: "success",
            });
            let pathInfo = this.$router.resolve({
              path: "/specialAccount/Speed",
              query: {
                id: res.data.data.innerForm.id,
                applyment_id: res.data.data.data.applyment_id,
              },
            });
            window.location.replace(pathInfo.href);
            // if (window.opener) {
            //   // 调用父窗口函数
            //   window.opener.getInfo();
            // }
            // setTimeout(() => {
            //   this.cancel();
            // }, 1000);
          })
          .catch((err) => {
            load.close();
            this.$message.error(err.message);
            console.log("失败", err);
          });
      });
    },
    getApplymentData(id) {
      this.$http
        .post("/pay/getApplymentData", {
          id: id,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error",
            });
            return;
          }
          this.innerForm = res.data.data[0];
        })
        .catch((err) => {
          load.close();
          this.$message.error(err.message);
          console.log("失败", err);
        });
    },
    handleAreaChange(val) {
      this.innerForm.bank_address_code = val;
    },
    // 上传成功
    handleAvatarSuccess(res, file, prop) {
      if (res && res.code == 0) {
        this.loading && this.loading.close();
        if (res.data.err) {
          return this.$message.error(res.data.errMsg);
        }
        if (res.data.OCRRes.errcode) {
          return this.$message.error("识别失败，请重新上传");
        }
        this.innerForm[prop + "_img"] = res.data.url;
        this.innerForm[prop] = res.data.media_id;
        if (prop == "id_card_copy") {
          if (res.data.OCRRes.type === "Back") {
            this.innerForm[prop + "_img"] = "";
            this.innerForm[prop] = "";
            return this.$message.error("请上传身份证正面照片");
          }
          this.innerForm.id_card_number = res.data.OCRRes.id;
          this.innerForm.id_card_name = res.data.OCRRes.name;
          this.innerForm.id_card_address = res.data.OCRRes.addr;
        }
        if (prop == "id_card_national") {
          if (res.data.OCRRes.type === "Front ") {
            this.innerForm[prop + "_img"] = "";
            this.innerForm[prop] = "";
            return this.$message.error("请上传身份证国徽照片");
          }
          // const regex = /^(\d{4}\d{2}\d{2})-(\d{4}\d{2}\d{2}|长期)$/;
          // const matches = res.data.OCRRes.valid_date.match(regex);
          // if (matches) {
          //   this.innerForm.card_period_begin = matches[1];
          //   this.innerForm.card_period_end =
          //     matches[2] === "长期" ? "长期" : matches[2];
          // }
          let input = res.data.OCRRes.valid_date;
          // 如果输入是以"长期"结尾
          if (input.endsWith("长期")) {
            // 将输入字符串中的日期部分提取出来
            var startDate = input.substr(0, 8);
            var endDate = "长期";
          } else {
            // 将输入字符串中的起始日期和结束日期提取出来
            var startDate = input.substr(0, 8);
            var endDate = input.substr(9, 8);
          }

          // 在日期字符串中插入"-"字符来分隔年、月和日
          startDate = startDate.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
          endDate = endDate.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
          this.innerForm.card_period_begin = startDate;
          this.innerForm.card_period_end = endDate;
        }
        if (prop == "license_copy") {
          this.innerForm.license_number = res.data.OCRRes.reg_num;
          this.innerForm.merchant_name = res.data.OCRRes.enterprise_name;
          this.innerForm.account_name = res.data.OCRRes.enterprise_name;
          this.innerForm.contact_name = res.data.OCRRes.legal_representative;
          this.innerForm.legal_person = res.data.OCRRes.legal_representative;
        }
      } else {
        this.$message({
          showClose: true,
          message: "上传失败",
          type: "error",
        });
      }
      this.loading && this.loading.close();
      this.$refs.innerForm.validateField(prop + "_img");
    },
    // 上传之前
    beforeAvatarUpload(file) {
      let ftype =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp";

      if (!ftype) {
        this.$message.error("图片只支持JPG、BMP、PNG格式!");
      }
      //设置文件大小限制
      const isLt10M = file.size / 1024 / 1024 < 2;
      if (!isLt10M) {
        this.$message.error("上传的照片大小不能超过 2MB!");
        return false;
      }
      this.loading = this.$loading();
      return ftype;
    },
  },
};
</script>

<style></style>
